'use client'

import type { CrossSellingClientProps } from 'cross-selling/types'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import dynamic from 'next/dynamic'
import { useRef } from 'react'

const DynamicClientCrossSelling = dynamic(() =>
	import('./DynamicClientCrossSelling').then(
		(mod) => mod.DynamicClientCrossSelling
	)
)

export const ClientCrossSelling = ({
	crossSellingItems,
	dataTestId,
	imageSortCriteria,
	title,
	location,
	productListId,
	className,
	variant,
	action,
}: CrossSellingClientProps) => {
	const clientCrossSellingRef = useRef(null) // Falta definir la referencia

	const productCardEntry = useIntersectionObserver(clientCrossSellingRef, {
		threshold: [0, 1],
		rootMargin: '0px 0px 150px 0px',
		freezeOnceVisible: true,
	})

	return (
		<div ref={clientCrossSellingRef}>
			{productCardEntry?.isIntersecting ? (
				<DynamicClientCrossSelling
					crossSellingItems={crossSellingItems}
					data-testid={dataTestId}
					imageSortCriteria={imageSortCriteria}
					title={title}
					location={location}
					productListId={productListId}
					className={className}
					variant={variant}
					action={action}
				/>
			) : null}
		</div>
	)
}
